import React from 'react';
import Helmet from 'react-helmet';
import ScrollableAnchor from 'react-scrollable-anchor';
import querystring from 'querystring';
import translations from '../translations';
import Reason from '../components/Reason';

import '../style/base.css';
import '../style/index.scss';
import '../style/responsive.scss';

import logoImage from '../assets/images/logo.png';
import favicon from '../assets/images/favicon.png';
import heroBackground from '../assets/images/hero-bg.png';
import cowboysLogoImageEN from '../assets/images/cowboys-logo_en.png';
import cowboysLogoImagePT from '../assets/images/cowboys-logo_pt.png';
import cowboysTextImageEN from '../assets/images/cowboys-text_en.png';
import cowboysTextImagePT from '../assets/images/cowboys-text_pt.png';
import reason1Image from '../assets/images/reason1.png';
import reason2Image from '../assets/images/reason2.png';
import reason3Image from '../assets/images/reason3.png';
import reason4Image from '../assets/images/reason4.png';
import cornerBackImage from '../assets/images/services-corner-back.png';
import cornerFrontImageEN from '../assets/images/services-corner-front_en.png';
import cornerFrontImagePT from '../assets/images/services-corner-front_pt.png';
import homeawayBrandImage from '../assets/images/brands/home-away.png';
import expediaBrandImage from '../assets/images/brands/expedia.png';
import atraveoBrandImage from '../assets/images/brands/atraveo.png';
import bookingBrandImage from '../assets/images/brands/booking.png';
import agodaBrandImage from '../assets/images/brands/agoda.png';
import airbnbBrandImage from '../assets/images/brands/airbnb.png';
import onlyapartmentsBrandImage from '../assets/images/brands/only-apartments.png';
import tripadvisorBrandImage from '../assets/images/brands/tripadvisor.png';
import checkImage from '../assets/images/check.png';
import visitUsImageEN from '../assets/images/visitus_en.png';
import visitUsImagePT from '../assets/images/visitus_pt.png';
import facebookImage from '../assets/images/social-facebook.png';
import instagramImage from '../assets/images/social-instagram.png';
import innovation1Image from '../assets/images/innovation1.jpg';
import innovation2Image from '../assets/images/innovation2.png';
import innovation3Image from '../assets/images/innovation3.jpg';

const LANG = 'en';

const t = translations[LANG];

const cowboysLogoImage = LANG === 'en' ? cowboysLogoImageEN : cowboysLogoImagePT;
const cowboysTextImage = LANG === 'en' ? cowboysTextImageEN : cowboysTextImagePT;
const cornerFrontImage = LANG === 'en' ? cornerFrontImageEN : cornerFrontImagePT;
const visitUsImage = LANG === 'en' ? visitUsImageEN : visitUsImagePT;

const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
};

class IndexPage extends React.Component {
  state = {
    selectedHouseType: '',
    address: '',
    email: '',
    phoneNumber: '',
    selectedHouseTypeError: '',
    addressError: '',
    emailError: '',
    phoneNumberError: '',
    submitted: false,
    bottomButtonId: '#form-section',
  };

  setField = (field, value) => {
    this.setState({
      [field]: value,
      [field + 'Error']: false,
    });
  };

  onSubmit = event => {
    event.preventDefault();
    this.setState({
      selectedHouseTypeError: '',
      addressError: '',
      emailError: '',
    });
    const { selectedHouseType, address, email, phoneNumber } = this.state;
    let selectedHouseTypeError = '';
    let addressError = '';
    let emailError = '';
    if (!selectedHouseType.trim()) {
      selectedHouseTypeError = 'Campo obrigatório';
    }
    if (!address.trim()) {
      addressError = 'Campo obrigatório';
    }
    if (!email.trim()) {
      emailError = 'Campo obrigatório';
    } else if (!email.match(/^\S+@\S+\.\S+$/)) {
      emailError = 'Formato inválido (e.g. email@exemplo.pt)';
    }

    this.setState({
      selectedHouseTypeError,
      addressError,
      emailError,
    });

    if (!selectedHouseTypeError && !addressError && !emailError) {
      const queryParams = {
        email,
        freguesia: address,
        phone: phoneNumber,
        tipologia: selectedHouseType,
      };
      Promise.all([
        fetch('.netlify/functions/subscribe?' + querystring.stringify(queryParams), { method: 'POST' }),        
        fetch('/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: encode({
            'form-name': 'contact',
            ...{
              [t.formHouseType]: selectedHouseType,
              [t.formAddress]: address,
              [t.formEmail]: email,
              [t.formPhoneNumber]: phoneNumber,
            },
          }),
        }) 
      ])
        .then(() => {
          this.setState({
            submitted: true,
          });
          if (process.env.NODE_ENV === 'production') {
            window.gtag('event', 'submit', {
              event_category: 'Contact',
              branch: process.env.BRANCH || 'none',
            });
            window.fbq('track', 'CompleteRegistration', {
              value: 1,
            });
          }
        })
        .catch(error => alert(error));
    }
  };

  componentDidMount() {
    this.setState({
      bottomButtonId: '#form-anchor',
    });
  }

  render() {
    return (
      <div id="root">
        <Helmet title={t.pageTitle} meta={[{ name: 'description', content: t.pageDescription }]}>
          <link rel="shortcut icon" type="image/png" href={favicon} />
        </Helmet>
        {/**** HEADER ****/}
        <section id="header">
          <div id="logo-wrapper">
            <img src={logoImage} alt="" />
          </div>
          <div id="header-contacts">
            <span>
              <a href={`mailto:${t.email}`}>
                <span>{t.email}</span>
              </a>
              <a href="tel://+351935899182">
                <span className="phone-number">+351 935 899 182</span>
              </a>
            </span>
            <span>Largo do Rato, 7 A/B - Lisboa</span>
          </div>
        </section>
        {/**** HERO ****/}
        <section id="hero">
          <picture className="hero-bg">
            <source
              media="all"
              srcSet={this.props.data.heroImage.sizes.srcSetWebp}
              type="image/webp"
            />
            <img
              srcSet={this.props.data.heroImage.sizes.srcSet}
              sizes={this.props.data.heroImage.sizes.sizes}
              src={heroBackground}
              alt=""
            />
          </picture>

          <picture className="hero-left">
            <source
              media="all"
              srcSet={this.props.data.cowboysLogoImage.sizes.srcSetWebp}
              type="image/webp"
            />
            <img
              srcSet={this.props.data.cowboysLogoImage.sizes.srcSet}
              sizes={this.props.data.cowboysLogoImage.sizes.sizes}
              src={cowboysLogoImage}
              alt=""
            />
          </picture>

          <picture className="hero-right">
            <source
              media="all"
              srcSet={this.props.data.cowboysTextImage.sizes.srcSetWebp}
              type="image/webp"
            />
            <img
              srcSet={this.props.data.cowboysTextImage.sizes.srcSet}
              sizes={this.props.data.cowboysTextImage.sizes.sizes}
              src={cowboysTextImage}
              alt=""
            />
          </picture>
        </section>
        {/**** FORM-SECTION ****/}
        <ScrollableAnchor id="form-anchor">
          <section id="form-section">
            <h1>
              {t.formTitle1}
              <br />
              {t.formTitle2}
            </h1>
            <p>{t.formText1}</p>
            {this.state.submitted ? (
              <div id="form-success">
                <p>
                  {t.formSuccessText1}
                  <br />
                  {t.formSuccessText2}
                </p>
              </div>
            ) : (
              <form name="contact" data-netlify="true" data-netlify-honeypot="hidden-field">
                <input
                  className="hidden-field"
                  name="hidden-field"
                  placeholder="Nome"
                  type="text"
                />
                <label>
                  <span>{t.formHouseType}</span>
                  <select
                    id="form-houseType"
                    name={t.formHouseType}
                    className={
                      this.state.selectedHouseTypeError
                        ? 'error'
                        : !this.state.selectedHouseType && 'unselected'
                    }
                    value={this.state.selectedHouseType}
                    onChange={event => this.setField('selectedHouseType', event.target.value)}
                    data-hj-whitelist
                    required
                  >
                    <option disabled value="" />
                    <option value="T0">T0</option>
                    <option value="T1">T1</option>
                    <option value="T2">T2</option>
                    <option value="T3">T3</option>
                    <option value="T4">T4</option>
                    <option value="T5">T5</option>
                  </select>
                </label>
                {this.state.selectedHouseTypeError && (
                  <p className="error">{this.state.selectedHouseTypeError}</p>
                )}
                <label>
                  <span>{t.formAddress}</span>
                  <input
                    id="form-address"
                    name={t.formAddress}
                    className={this.state.addressError && 'error'}
                    type="text"
                    value={this.state.address}
                    onChange={event => this.setField('address', event.target.value)}
                    data-hj-whitelist
                    required
                  />
                </label>
                {this.state.addressError && <p className="error">{this.state.addressError}</p>}
                <label>
                  <span>{t.formEmail}</span>
                  <input
                    id="form-email"
                    name={t.formEmail}
                    className={this.state.emailError && 'error'}
                    type="email"
                    value={this.state.email}
                    onChange={event => this.setField('email', event.target.value)}
                    data-hj-whitelist
                    required
                  />
                </label>
                {this.state.emailError && <p className="error">{this.state.emailError}</p>}
                <label>
                  <span>{t.formPhoneNumber}</span>
                  <input
                    name={t.formPhoneNumber}
                    type="tel"
                    value={this.state.phoneNumber}
                    onChange={event => this.setField('phoneNumber', event.target.value)}
                    data-hj-whitelist
                  />
                </label>
                <button className="button" id="submit-form-button" onClick={this.onSubmit}>
                  {t.formSubmit}
                </button>
              </form>
            )}
          </section>
        </ScrollableAnchor>
        {/**** REASONS ****/}
        <ScrollableAnchor id="reasons-anchor">
          <section id="reason-section">
            <h2>
              {t.reasonsTitle1}
              <br />
              {t.reasonsTitle2}
            </h2>
            <p>{t.reasonsText}</p>
            <div id="reasons">
              <Reason image={reason1Image} title={t.reason1Title} text={t.reason1Text} />
              <Reason image={reason2Image} title={t.reason2Title} text={t.reason2Text} />
              <Reason image={reason3Image} title={t.reason3Title} text={t.reason3Text} />
              <Reason image={reason4Image} title={t.reason4Title} text={t.reason4Text} />
            </div>
          </section>
        </ScrollableAnchor>

        {/**** Innovation ****/}
        <ScrollableAnchor id="innovation-anchor">
          <section id="innovation-section">
            <h2>
              {t.innovationTitle1}
              <br />
              {t.innovationTitle2}
            </h2>
            <div id="innovations">
              <div className="innovation">
                <img src={innovation1Image} alt="" />
                <p>{t.innovation1Text}</p>
              </div>
              <div className="innovation">
                <img src={innovation2Image} alt="" />
                <p>{t.innovation2Text}</p>
              </div>
              <div className="innovation">
                <img src={innovation3Image} alt="" />
                <p>{t.innovation3Text}</p>
              </div>
            </div>
          </section>
        </ScrollableAnchor>

        {/**** SERVICES ****/}
        <section id="services-section">
          <h2>{t.servicesTitle}</h2>
          <div id="services-content-box">
            <img id="services-corner-back" src={cornerBackImage} alt="" />
            <div id="services-content-main">
              <div id="services-subtitle">
                <h3>
                  20<span>%</span>
                </h3>
                <h4>{t.servicesText2}</h4>
                <h4 className="services-subtitle--dark">{t.servicesText3}</h4>
                <h4>{t.servicesText4}</h4>
              </div>
              <div id="services-brands">
                <div>
                  <img className="brand-homeaway" src={homeawayBrandImage} alt="" />
                </div>
                <div>
                  <img className="brand-expedia" src={expediaBrandImage} alt="" />
                </div>
                <div>
                  <img className="brand-atraveo" src={atraveoBrandImage} alt="" />
                </div>
                <div>
                  <img className="brand-booking" src={bookingBrandImage} alt="" />
                </div>
                <div>
                  <img className="brand-agoda" src={agodaBrandImage} alt="" />
                </div>
                <div>
                  <img className="brand-airbnb" src={airbnbBrandImage} alt="" />
                </div>
                <div>
                  <img className="brand-onlyapartments" src={onlyapartmentsBrandImage} alt="" />
                </div>
                <div>
                  <img className="brand-tripadvisor" src={tripadvisorBrandImage} alt="" />
                </div>
              </div>
            </div>

            <picture id="services-corner-front">
              <source
                media="all"
                srcSet={this.props.data.servicesCornerImage.sizes.srcSetWebp}
                type="image/webp"
              />
              <img
                srcSet={this.props.data.servicesCornerImage.sizes.srcSet}
                sizes={this.props.data.servicesCornerImage.sizes.sizes}
                src={cornerFrontImage}
                alt=""
              />
            </picture>
            <ul id="services-content-list">
              <li>
                <img src={checkImage} alt="" /> {t.serviceListItem1}
              </li>
              <li>
                <img src={checkImage} alt="" /> {t.serviceListItem2}
              </li>
              <li>
                <img src={checkImage} alt="" /> {t.serviceListItem3}
              </li>
              <li>
                <img src={checkImage} alt="" /> {t.serviceListItem4}
              </li>
              <li>
                <img src={checkImage} alt="" /> {t.serviceListItem5}
              </li>
              <li>
                <img src={checkImage} alt="" /> {t.serviceListItem6}
              </li>
              <li>
                <img src={checkImage} alt="" /> {t.serviceListItem7}
              </li>
              <li>
                <img src={checkImage} alt="" /> {t.serviceListItem8}
              </li>
              <li>
                <img src={checkImage} alt="" /> {t.serviceListItem9}
              </li>
              <li>
                <img src={checkImage} alt="" /> {t.serviceListItem10}
              </li>
              <li>
                <img src={checkImage} alt="" /> {t.serviceListItem11}
              </li>
              <li>
                <img src={checkImage} alt="" /> {t.serviceListItem12}
              </li>
            </ul>
          </div>
        </section>

        {/**** NEW-SERVICES ****/}
        <section id="new-services-section">
          <h4>{t.newServicesText}</h4>
        </section>

        {/**** LOCATION ****/}
        <section id="location-section">
          <div id="location-address">
            <img src={visitUsImage} alt="" />
            <h4>{t.locationAddressTitle}</h4>
            <span>{t.locationAddressText1}</span>
            <span>{t.locationAddressText2}</span>
          </div>
          <div id="location-map">
            <a
              alt="mapa"
              href="https://www.google.com/maps/search/?api=1&amp;query=38.7199197,-9.1546162&amp;key=AIzaSyBViRbgQFh6HWt9Ivo9R7mF0Qj3bdzB1dU"
            >
              <img
                alt=""
                src="https://maps.googleapis.com/maps/api/staticmap?markers=38.7199197,-9.1546162&amp;zoom=16&amp;size=250x250&amp;scale=2&amp;key=AIzaSyBViRbgQFh6HWt9Ivo9R7mF0Qj3bdzB1dU"
              />
            </a>
          </div>
          <div id="location-contacts">
            <h4>{t.locationContactsTitle}</h4>
            <a href="tel://+351935899182">+351 935 899 182</a>
            <a href="tel://+351935899213">+351 935 899 213</a>
            <a href={`mailto:${t.email}`}>{t.email}</a>
          </div>
        </section>
        {/**** IMAGE-BAR ****/}
        <section id="image-bar-section">
          <h2>{t.imageBarTitle}</h2>
          <a href={this.state.bottomButtonId}>
            <div className="button light">{t.imageBarButton}</div>
          </a>
        </section>

        {/**** FOOTER ****/}

        <section id="footer">
          <div>
            <a alt="Share facebook" href="https://www.facebook.com/homingallshortermrentals/">
              <img src={facebookImage} alt="" />
            </a>
            <a alt="Share instagram" href="https://www.instagram.com/homingplace/?hl=en">
              <img src={instagramImage} alt="" />
            </a>
          </div>
          <span>{t.footerText1}</span>
          <span>
            {t.footerText2} <a href="https://www.moscadigital.pt">Mosca Digital</a>
          </span>
        </section>
      </div>
    );
  }
}

// eslint-disable-next-line no-undef
export const pageQuery = graphql`
  query ImagesQuery {
    heroImage: imageSharp(id: { regex: "/hero-bg/" }) {
      sizes(maxWidth: 1500) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
    cowboysLogoImage: imageSharp(id: { regex: "/cowboys-logo_en/" }) {
      sizes(maxWidth: 700) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
    cowboysTextImage: imageSharp(id: { regex: "/cowboys-text_en/" }) {
      sizes(maxWidth: 1000) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
    servicesCornerImage: imageSharp(id: { regex: "/services-corner-front_en/" }) {
      sizes(maxWidth: 300) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`;

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js